<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<style>
html {
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f6f8fb;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    '微软雅黑', Arial, sans-serif;
  overflow: hidden;
  padding-right: 0 !important;
}
</style>

<script>
import { setCookie, removeCookie } from 'tiny-cookie'

export default {
  created() {
    if (window.location.search) {
      var next = window.location.search.split('?')[1].split('=')[1]
      if (next.indexOf('mobile') >= 0) {
        // 移动端登录
        removeCookie('login')
      }
    }
    let location_params = this.$route.query
    if (location_params.id) {
      setCookie('source', location_params.source)
      setCookie('am_id', location_params.id)
    }
  },
}
</script>
